module.exports = __webpack_public_path__ + "img/logo_login-2.e6709924.png";